import React from "react";
import { DataPointCard } from "../DataPointCard";
import moment from "moment";
import {
  Button,
  Intent,
  Menu,
  MenuDivider,
  MenuItem,
  PopoverInteractionKind,
  Classes
} from "@blueprintjs/core";
import Icon from "../../atoms/Icon/Icon";
import { DatePicker } from "@blueprintjs/datetime";

import classNames from "classnames";
import styles from "./OpportunityDetails.module.scss";

function OpportunityDataPointCards({
  opportunity,
  onVisibilityChange,
  onExpirationChange,
  onExpirationExtended,
  isReadOnly
}) {
  const earnings = opportunity.stats ? opportunity.stats.earnings : 0;
  const earningsString = `$${earnings.toFixed(2)}`;

  const isOpportunityPercentage = !!opportunity.isPercentage;
  const isOpportunityPresent = !!opportunity.amount;

  const dollarOpportunityAmount = !isOpportunityPresent
    ? "$0.00"
    : `$${opportunity.amount.toFixed(2)}`;

  const commission =
    isOpportunityPercentage && isOpportunityPresent
      ? `${opportunity.amount.toFixed(2)}%`
      : dollarOpportunityAmount;

  const numberOfDaysFromTwentyYearsFromNow = 365 * 20;
  const twentyYearsFromNow = new Date();
  twentyYearsFromNow.setDate(
    twentyYearsFromNow.getDate() + numberOfDaysFromTwentyYearsFromNow
  );

  const minDate = opportunity.expiresAt
    ? new Date(opportunity.expiresAt)
    : new Date();

  return (
    <div className={styles.headerWrapper}>
      <DataPointCard
        color="#09A496"
        iconName="Visibility"
        title="OPPORTUNITY VISIBILITY"
        value={opportunity.visibility === "Public" ? "PUBLIC" : "PRIVATE"}
        menu={!isReadOnly && (
          <Menu>
            <MenuDivider
              className={styles.menuTitle}
              title="Opportunity Visibility"
            />
            <MenuDivider />
            <MenuItem
              text="Public"
              className={
                opportunity && opportunity.visibility === "Public"
                  ? styles.selectedMenuItem
                  : null
              }
              labelElement={
                opportunity && opportunity.visibility === "Public" ? (
                  <Icon name="tick" size={11} color="#00998c" />
                ) : null
              }
              onClick={() => onVisibilityChange("Public")}
            />
            <MenuItem
              text="Private"
              className={
                opportunity && opportunity.visibility === "Private"
                  ? styles.selectedMenuItem
                  : null
              }
              labelElement={
                opportunity && opportunity.visibility === "Private" ? (
                  <Icon name="tick" size={11} color="#00998c" />
                ) : null
              }
              onClick={() => onVisibilityChange("Private")}
            />
          </Menu>
        )}
      />
      <DataPointCard
        color="#FF5D78"
        iconName="Expiration"
        title="EXPIRATION DATE"
        value={
          opportunity.expiresAt
            ? moment(new Date(opportunity.expiresAt)).format("MM/D/YY")
            : " "
        }
        menu={!isReadOnly && (
          <Menu>
            <MenuDivider className={styles.menuTitle} title="Expiration Date" />
            <MenuDivider />
            <MenuItem
              text="Extend Expiration Date"
              popoverProps={{ interactionKind: PopoverInteractionKind.CLICK }}
            >
              <DatePicker
                defaultValue={minDate}
                minDate={minDate}
                maxDate={twentyYearsFromNow}
                onChange={onExpirationChange}
              />
              <Button
                className={classNames(
                  styles.extendOpportunityButton,
                  Classes.POPOVER_DISMISS
                )}
                intent={Intent.PRIMARY}
                text="Apply"
                onClick={onExpirationExtended}
              />
            </MenuItem>
          </Menu>
        )}
      />
      <DataPointCard
        color="#09A496"
        iconName="Earnings"
        title="SALES EARNINGS"
        value={earningsString}
      />
      <DataPointCard
        color="#FF5D78"
        iconName="Commission"
        title="COMMISSION RATE"
        value={commission}
      />
      <DataPointCard
        color="#09A496"
        iconName="Views"
        title="# OF VIDEO VIEWS"
        value={opportunity.stats ? opportunity.stats.views : 0}
      />
    </div>
  );
}

export default OpportunityDataPointCards;
